import { render, staticRenderFns } from "./BaseButtonWarningSmall.vue?vue&type=template&id=301da70d&"
import script from "./BaseButtonWarningSmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonWarningSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports